import React from "react";
import axios from "axios";
// import {CustomLoading} from "../../components/CustomLoading";
// import {CustomDateRangePicker} from "../../components/CustomDateRangePicker";
import "../../styles/Reports.css";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {CustomLoading} from "../../components/CustomLoading";
import {Table} from "react-bootstrap";
import CustomPagination from "../../components/CustomPagination";
import {EmptyStateTemplate} from "./Empty_state_Template";
import toastr from "toastr";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default class CorehealthReportTable extends React.Component<any, any> {
    constructor(props) {
        super(props);
        const date = new Date();
        this.state = {
            loading: true,
            data: [],
            dataToExport: [],
            // fromDate: new Date(date.getFullYear(), date.getMonth(), 1),
            // toDate: new Date(),
            currentPage: 1,
            itemsPerPage: 12,
        };
        this.fetchData = this.fetchData.bind(this);
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData = () => {
        axios.get("/api/Reports/getcorehealthinvoicesreport", {
            params: {
                policyId: this.props.policyId,
                // fromDate: this.state.fromDate,
                // toDate: this.state.toDate,
            }
        })
            .then(res => {
                if (res.data.success) {
                    this.setupData(res.data.invoices);
                } else {
                    this.setState({
                        loading: false,
                        data: [],
                        dataToExport: [],
                    });
                }
            });
    }
    setupData = (data) => {
        let dataToExport = [];
        let invoices = data;
        // const { fromDate, toDate } = this.state;
        // const formattedFromDate = fromDate.toISOString().slice(0,10);
        // const formattedToDate = toDate.toISOString().slice(0,10);
        invoices.forEach(inv => {
            dataToExport.push([
                inv.id,
                inv.invoiceDate,
                inv.invoiceNo,
                inv.policyId,
                inv.totalCertificates,
                inv.invoiceAmount,
                inv.taxAmount,
                inv.totalInvoiceAmount,
                inv.balanceAtBilling,
                inv.holdAmountAtBilling,
                inv.status,
                inv.isApproved,
                inv.isPaid
            ]);
        });
        const headerRow = ["Invoice Date", "Invoice No.", "Employees", "Total Premiums", "Total Tax", "Total Invoice", "Balance at Billing", "Amount Owing", "Status"];
        dataToExport.unshift(headerRow);
        this.setState({
            dataToExport: dataToExport,
            data: invoices,
            loading: false,
        });
    };
    setCurrentPage = (page) => {
        this.setState({currentPage: page});
    }
    toDataURL = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    downloadInvoice = (inv) => {
        axios.get("/api/Reports/getcorehealthinvoice", {
            params: {
                policyId: inv.policyId,
                invoiceId: inv.id
                // fromDate: this.state.fromDate,
                // toDate: this.state.toDate,
            }
        })
            .then(res => {
                if (res.data.success) {
                    this.toDataURL('/corehealthinvoiceheader.png', (headerImage) => {
                        this.toDataURL('/corehealthinvoicelogo.png', (logoImage) => {
                            this.toDataURL('/corehealthinvoicefooter.png', (footerImage) => {
                                this.generatePdf(headerImage, logoImage, footerImage, res.data);
                            });
                        });
                    });
                } else {
                    toastr.error("Failed to download invoice")
                }
            });
    }

    generatePdf = (headerImage, logoImage, footerImage, invoiceData) => {
        let invoiceDate = invoiceData.invoice.invoice.invoiceDate;
        let parsedDate = new Date(invoiceDate);
        let formattedInvoiceDate = parsedDate.toLocaleDateString('default', {
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        });
        let formattedInvoiceDebitDate = `15 ${parsedDate.toLocaleDateString('default', {
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        })}`;
        let totalInvoiceAmount = parseFloat(invoiceData.invoice.invoice.totalInvoiceAmount);
        let balanceAtBilling = parseFloat(invoiceData.invoice.invoice.balanceAtBilling) || 0;
        let holdAmountAtBilling = parseFloat(invoiceData.invoice.invoice.holdAmountAtBilling) || 0;
        let amountOwing = totalInvoiceAmount;
        let totalAmountOwing = 0;
        let outstandingInvoices = invoiceData.invoice.outstandingInvoices;
        let outstandingBalanceTable = null;
        if (Array.isArray(outstandingInvoices) && outstandingInvoices.length > 0) {
            outstandingInvoices.forEach(invoice => {
                amountOwing += invoice.totalInvoiceAmount;
            });
            outstandingBalanceTable = {
                table: {
                    headerRows: 1,
                    widths: ['*', '*', '*'],
                    body: [
                        [
                            {
                                text: 'Invoice No. (Outstanding)',
                                fillColor: '#444748',
                                color: '#fff',
                                alignment: 'center',
                                bold: true,
                                fontSize: 14,
                                margin: [0, 5, 0, 5]
                            },
                            {
                                text: 'Date',
                                fillColor: '#444748',
                                color: '#fff',
                                alignment: 'center',
                                bold: true,
                                fontSize: 14,
                                margin: [0, 5, 0, 5]
                            },
                            {
                                text: 'Total Invoice',
                                fillColor: '#444748',
                                color: '#fff',
                                alignment: 'center',
                                bold: true,
                                fontSize: 14,
                                margin: [0, 5, 0, 5]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineColor: '#747778',
                    vLineColor: '#747778',
                },
                margin: [40, 30, 40, 0]
            };
            outstandingInvoices.forEach((item, i) => {
                outstandingBalanceTable.table.body.push([
                    {
                        text: item.invoiceNo,
                        alignment: 'center',
                        margin: [0, 5, 0, 5]
                    },
                    {
                        text: item.invoiceDate,
                        alignment: 'center',
                        margin: [0, 5, 0, 5]
                    },
                    {
                        text: `$${item.totalInvoiceAmount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`,
                        alignment: 'right',
                        margin: [0, 5, 0, 5]
                    }
                ]);
            });
        }
        let availableBalance = balanceAtBilling + holdAmountAtBilling;
        totalAmountOwing = Math.max(0, amountOwing - availableBalance);
        let holdAmountText = null;
        if (holdAmountAtBilling > 0) {
            holdAmountText = {
                text: `CHQ Hold Amount: $${holdAmountAtBilling.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`,
                fontSize: 12,
                margin: [40, 5, 40, 0],
                alignment: 'right',
                bold: false
            };
        }
        const docDefinition = {
            pageMargins: [0, 50, 0, 110],
            content: [
                {
                    image: logoImage,
                    width: 200,
                    absolutePosition: {x: 20, y: 25},
                },
                {
                    stack: [
                        {
                            text: [
                                {text: 'Invoice No: ', bold: true},
                                `${invoiceData.invoice.invoice.invoiceNo}`
                            ],
                        },
                        {
                            text: [
                                {text: 'Invoice Date: ', bold: true},
                                `${invoiceData.invoice.invoice.invoiceDate}`
                            ],
                        },
                        {
                            text: [
                                {text: 'Policy No: ', bold: true},
                                `${invoiceData.invoice.policyHolder.policyNo}`
                            ],
                        }
                    ],
                    absolutePosition: {x: 330, y: 50},
                    width: 400,
                    alignment: 'left',
                    fontSize: 13,
                },
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 280,
                            y2: 0,
                            lineWidth: 3,
                            lineColor: 'black',
                        }
                    ],
                    margin: [280, 90, 0, 0]
                },
                {
                    columns: [
                        {
                            stack: [
                                {text: 'INVOICE TO:', bold: true, margin: [0, 0, 0, 5]},
                                {text: `${invoiceData.invoice.policyHolder.name}`},
                                {text: `${invoiceData.invoice.policyHolder.mailingStreet1}`},
                                {text: `${invoiceData.invoice.policyHolder.mailingCity}, ${invoiceData.invoice.policyHolder.mailingProv}, ${invoiceData.invoice.policyHolder.mailingPostalCode}`}
                            ],
                            width: '50%',
                            alignment: 'left',
                            margin: [40, 40, 0, 0],
                            fontSize: 12,
                        },
                        {
                            stack: [
                                {text: 'INVOICE FROM:', bold: true, margin: [0, 0, 0, 5]},
                                {text: 'National HealthClaim'},
                                {text: '5320-7005 Fairmount Dr.'},
                                {text: 'SE Calgary, AB T2H 0K4'},
                                {text: '1-866-342-5908'}
                            ],
                            width: '50%',
                            alignment: 'left',
                            margin: [90, 40, 40, 0],
                            fontSize: 12,
                        }
                    ]
                },
                {
                    table: {
                        headerRows: 1,
                        widths: ['*', '*', '*', '*', '*'],
                        body: [
                            [
                                {
                                    text: 'Members',
                                    fillColor: '#444748',
                                    color: '#fff',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 14,
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: 'Rate',
                                    fillColor: '#444748',
                                    color: '#fff',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 14,
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: 'Premiums',
                                    fillColor: '#444748',
                                    color: '#fff',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 14,
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: 'OST (8%) *',
                                    fillColor: '#444748',
                                    color: '#fff',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 14,
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: 'Total Invoice',
                                    fillColor: '#444748',
                                    color: '#fff',
                                    alignment: 'center',
                                    bold: true,
                                    fontSize: 14,
                                    margin: [0, 5, 0, 5]
                                },
                            ], [
                                {
                                    text: `${invoiceData.invoice.invoice.totalCertificates}`,
                                    alignment: 'center',
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: `$29.99 Single / $39.99 Family`,
                                    alignment: 'right',
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: `$${invoiceData.invoice.invoice.invoiceAmount.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    alignment: 'right',
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: `$${invoiceData.invoice.invoice.taxAmount.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    alignment: 'right',
                                    margin: [0, 5, 0, 5]
                                },
                                {
                                    text: `$${invoiceData.invoice.invoice.totalInvoiceAmount.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    alignment: 'right',
                                    margin: [0, 5, 0, 5]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineColor: '#747778',
                        vLineColor: '#747778',
                    },
                    margin: [40, 30, 40, 0]
                },
                outstandingBalanceTable ? outstandingBalanceTable : {},
                {
                    text: `Available Balance: $${balanceAtBilling.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    fontSize: 12,
                    margin: [40, 20, 40, 0],
                    alignment: 'right',
                    bold: false
                },
                holdAmountText,
                {
                    text: `Amount Owing: $${totalAmountOwing.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    fontSize: 14,
                    margin: [40, 10, 40, 20],
                    alignment: 'right',
                    bold: true
                },
                {
                    ul: [
                        { text: "* In Ontario, insurance premiums are subject to OST.", bold: true },
                        { text: `The invoice total will be debited to your pre-authorized payment account during ${formattedInvoiceDate}. This invoice is for your information only. Do not pay.`, bold: true },
                        "For CoreHealth+ insurance premiums, National HealthClaim Corp acts as a billing agent and collects the premiums and OST on behalf of Wawanesa Life Insurance Company of Canada.",
                        "Wawanesa Life Insurance Company of Canada: OST# 85027537",
                        "CoreHealth+ Insurance Premiums are Private Health Service Plan Premiums for the premium-based insured component of the CoreHealth+ program.",
                        "For incorporated companies using CoreHealth+, the portion of the premium that is deemed to be \"Taxable Income\" is: Single employees: $24.79 / month, Family employees: $28.54 / month."
                    ],
                    fontSize: 12,
                    margin: [40, 30, 40, 20]
                },
                {
                    text: 'Member Eligibility List',
                    fontSize: 14,
                    bold: true,
                    margin: [40, 20, 40, 10],
                    pageBreak: 'before'
                },
                this.generateEligibilityTable(invoiceData)
            ],
            footer: (currentPage, pageCount) => {
                return {
                    columns: [
                        {
                            image: footerImage,
                            width: 595,
                            margin: [0, 0, 0, 0],
                            alignment: 'center',
                        },
                    ],
                    margin: [0, 30, 0, 0],
                };
                // if (currentPage === pageCount) {
                //     return {
                //         columns: [
                //             {
                //                 image: footerImage,
                //                 width: 595,
                //                 margin: [0, 0, 0, 0],
                //                 alignment: 'center',
                //             },
                //         ],
                //         margin: [0, -25, 0, 0],
                //     };
                // }
                // return null;
            },
        };
        pdfMake.createPdf(docDefinition).open();
    };

    downloadInvoiceCSV = (inv) => {
        axios.get("/api/Reports/getcorehealthinvoice", {
            params: {
                policyId: inv.policyId,
                invoiceId: inv.id
            }
        }).then(res => {
            if (res.data.success) {
                this.generateInvoiceCSV(res.data);
            } else {
                toastr.error("Failed to download invoice as CSV");
            }
        });
    };

    generateInvoiceCSV = (invoiceData) => {
        const showCostCentre = invoiceData.invoice.policyHolder.hasCostCentre;
        const showDivision = invoiceData.invoice.policyHolder.hasDivision;

        const headers = [
            "Last Name",
            "First Name",
            ...(showCostCentre ? ["Cost Centre"] : []),
            ...(showDivision ? ["Division"] : []),
            "Date of Birth",
            "OST",
            "Rate",
            "Province"
        ];

        const rows = invoiceData.invoice.invoiceData.map(member => [
            member.lastName || "",
            member.firstName || "",
            ...(showCostCentre ? [member.costCentre || ""] : []),
            ...(showDivision ? [member.division || ""] : []),
            member.dateOfBirth || "",
            member.gst || "",
            typeof member.amount === "number" ? member.amount.toFixed(2) : "",
            member.mailingProv || ""
        ]);

        const csvContent = [headers, ...rows]
            .map(row =>
                row.map(item => `"${String(item).replace(/"/g, '""')}"`).join(",")
            ).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `CoreHealth_Invoice_${invoiceData.invoice.invoice.invoiceNo}_Members.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Dynamic table that will show Division/Cost Centre
    generateEligibilityTable(invoiceData) {
    const showCostCentre = invoiceData.invoice.policyHolder.hasCostCentre;
    const showDivision = invoiceData.invoice.policyHolder.hasDivision;

    const tableWidths = [
        20, // Index
        '*', // Last Name
        '*', // First Name
        ...(showCostCentre ? ['*'] : []),
        ...(showDivision ? ['*'] : []),
        '*', // Date of Birth
        40,  // Rate
        40,  // OST/GST
        40   // Province
    ];

    const tableHeader = [
        {
            text: '#',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'center',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        {
            text: 'Last Name',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'left',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        {
            text: 'First Name',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'left',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        ...(showCostCentre ? [{
            text: 'Cost Centre',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'left',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        }] : []),
        ...(showDivision ? [{
            text: 'Division',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'left',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        }] : []),
        {
            text: 'Date of Birth',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'left',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        {
            text: 'OST (8%) *', // or 'GST (5%)' if needed
            fillColor: '#444748',
            color: '#fff',
            alignment: 'center',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        {
            text: 'Rate',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'center',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        },
        {
            text: 'Province',
            fillColor: '#444748',
            color: '#fff',
            alignment: 'center',
            bold: true,
            fontSize: 10,
            margin: [0, 5, 0, 5]
        }
    ];

    const tableBody = [
        tableHeader,
        ...invoiceData.invoice.invoiceData
            .filter(member => {
                // Optional: skip rows with all key fields missing
                return member.firstName || member.lastName || member.amount || member.dateOfBirth;
            })
            .map((member, index) => {
                return [
                    { text: `${index + 1}`, alignment: 'center', fontSize: 10, margin: [0, 5, 0, 5] },
                    { text: member.lastName || 'N/A', alignment: 'left', fontSize: 10, margin: [0, 5, 0, 5] },
                    { text: member.firstName || 'N/A', alignment: 'left', fontSize: 10, margin: [0, 5, 0, 5] },
                    ...(showCostCentre ? [{
                        text: member.costCentre || 'N/A',
                        alignment: 'left',
                        fontSize: 10,
                        margin: [0, 5, 0, 5]
                    }] : []),
                    ...(showDivision ? [{
                        text: member.division || 'N/A',
                        alignment: 'left',
                        fontSize: 10,
                        margin: [0, 5, 0, 5]
                    }] : []),
                    { text: member.dateOfBirth || 'N/A', alignment: 'left', fontSize: 10, margin: [0, 5, 0, 5] },
                    { text: member.gst || 'N/A', alignment: 'right', fontSize: 10, margin: [0, 5, 0, 5] },
                    {
                        text: member.amount !== undefined && member.amount !== null
                            ? `$${member.amount.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`
                            : 'N/A',
                        alignment: 'right',
                        fontSize: 10,
                        margin: [0, 5, 0, 5]
                    },
                    { text: member.mailingProv || 'N/A', alignment: 'center', fontSize: 10, margin: [0, 5, 0, 5] }
                ];
            })
    ];

    return {
        table: {
            headerRows: 1,
            widths: tableWidths,
            body: tableBody
        },
        layout: {
            hLineColor: '#747778',
            vLineColor: '#747778',
        },
        margin: [40, 20, 40, 0]
    };
    }

    render() {
        let contents = null;
        if (this.state.loading) {
            contents = (<CustomLoading/>);
        } else {
            const indexOfLastRecord = this.state.currentPage * this.state.itemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.itemsPerPage;
            const currentRecords = this.state.data.slice(indexOfFirstRecord, indexOfLastRecord);
            const nPages = Math.ceil(this.state.data.length / this.state.itemsPerPage);
            contents = (
                <div className="invoices-table report-table-container">
                    {this.state.data.length > 0 ? (
                        <>
                            <Table hover className="report-table">
                                <thead>
                                <tr>
                                    <th className="table-text-content">Invoice Date</th>
                                    <th className="table-text-content">Invoice No.</th>
                                    <th className="">Employees</th>
                                    <th className="">Total Premiums</th>
                                    <th className="">Total Tax</th>
                                    <th className="">Total Invoice</th>
                                    <th className="">Balance at Billing</th>
                                    <th className="">Amount Owing</th>
                                    <th className="table-text-content">Status</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {currentRecords.map((inv, index) => (
                                    <tr key={index}>
                                        <td className="table-text-content">{inv.invoiceDate}</td>
                                        <td className="table-text-content">{inv.invoiceNo}</td>
                                        <td className="">{inv.totalCertificates}</td>
                                        <td className="">${inv.invoiceAmount}</td>
                                        <td className="">${inv.taxAmount}</td>
                                        <td className="">${inv.totalInvoiceAmount}</td>
                                        <td className="">${inv.balanceAtBilling}</td>
                                        <td className="">
                                            {inv.isApproved ? (
                                                "Paid"
                                            ) : (
                                                `$${Math.max(0, (inv.totalInvoiceAmount - inv.balanceAtBilling)).toFixed(2)}`
                                            )}
                                        </td>
                                        <td className="table-text-content">{inv.status}</td>
                                        <td>
                                            <button className={"btn btn-outline-primary btn-sm"}
                                                    onClick={() => this.downloadInvoice(inv)}>PDF Download
                                            </button>
                                        </td>
                                        <td>
                                             <button className={"btn btn-outline-primary btn-sm"}
                                                    onClick={() => this.downloadInvoiceCSV(inv)}>CSV Download
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    <span>Showing {indexOfFirstRecord + 1} - {indexOfFirstRecord + currentRecords.length} entries out of {this.state.data.length} entries</span>
                                </div>
                                <CustomPagination
                                    nPages={nPages}
                                    currentPage={this.state.currentPage}
                                    setCurrentPage={this.setCurrentPage}
                                />
                            </div>
                        </>
                    ) : (
                        <EmptyStateTemplate/>
                    )}
                </div>
            );
        }
        return (<>{contents}</>);
    }
}

